import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleLeftLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M13.125 7.02c1.167-.673 2.625.169 2.625 1.516v6.928c0 1.347-1.458 2.19-2.625 1.516l-6-3.465c-1.167-.673-1.167-2.357 0-3.03zm1.125 1.516a.25.25 0 0 0-.375-.217l-6 3.464a.25.25 0 0 0 0 .433l6 3.465a.25.25 0 0 0 .375-.217z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleLeftLine)
export default ForwardRef
